const isDevelopment = process.env.NODE_ENV === 'development';

export const baseUrl = process.env.REACT_APP_HOLEDO_BASE_URL || (isDevelopment ? 'http://localhost' : 'https://api.holedo.com');
export const appUrl = process.env.REACT_APP_HOLEDO_FRONTEND_URL || (isDevelopment ? 'http://localhost' : 'https://holedo.com');
export const testMode = process.env.TEST_MODE || false;
